'use strict';


let KDLoadouts: Record<string, KDLoadout> = {
	"guard": {
		name: "guard",
		tags: ["elite"],
		singletag: ["human", "elf", "alchemist", "dragon", "witch", "apprentice", "mummy", "jailer"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.5,
		items: ["RedKey", "BasicLeash"],
	},
	"thief": {
		name: "thief",
		tags: ["human"],
		singletag: ["bandit", "bountyhunter"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.15,
		items: ["Pick", "Knife", "DiscPick"],
	},
	"thief2": {
		name: "thief2",
		tags: ["human"],
		singletag: ["bandit", "bountyhunter"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.15,
		items: ["Pick", "FlashBomb", "DiscPick",],
	},
	"mistress": {
		name: "mistress",
		tags: ["miniboss"],
		singletag: ["human", "elf", "alchemist", "dragon", "witch", "apprentice", "mummy"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.65,
		items: ["RedKey"],
	},
	"scientist_I": {
		name: "scientist_I",
		tags: ["alchemist"],
		singletag: ["alchemist"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.65,
		items: ["SmokeBomb"],
	},
	"scientist_II": {
		name: "scientist_II",
		tags: ["alchemist"],
		singletag: ["alchemist"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.5,
		items: ["PotionFrigid", "PotionStamina"],
	},
	"scientist_III": {
		name: "scientist_III",
		tags: ["alchemist"],
		singletag: ["alchemist"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.5,
		items: ["PotionMana", "FlashBomb"],
	},
	"scientist_IV": {
		name: "scientist_IV",
		tags: ["alchemist"],
		singletag: ["alchemist"],
		forbidtags: ["submissive", "gagged", "minor"],
		chance: 0.4,
		items: ["PotionStamina", "PotionStrength"],
	},
	"scientist_V": {
		name: "scientist_V",
		tags: ["alchemist"],
		singletag: ["alchemist"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.2,
		items: ["PotionInvisibility"],
	},

	"scientist_High": {
		name: "scientist_High",
		tags: ["alchemist"],
		singletag: ["alchemist", "latex"],
		singletag2: ["miniboss", "boss"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.25,
		items: ["UniversalSolvent"],
	},
	"magus": {
		name: "magus",
		tags: [],
		singletag: ["dressmaker", "elf", "witch", "apprentice", "mummy", "fungal"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.05,
		multiplier: 10,
		items: ["BlueKey", "PotionMana", "ScrollVerbal", "ScrollLegs", "ScrollArms"],
	},
	"magusElite": {
		name: "magusElite",
		tags: [],
		singletag: ["dressmaker", "elf", "witch", "apprentice", "mummy", "fungal"],
		singletag2: ["elite", "miniboss", "boss"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.6,
		multiplier: 10,
		items: ["BlueKey", "PotionMana", "PotionMana", "ScrollVerbal", "ScrollLegs", "ScrollArms"],
	},
	"scroll_arm": {
		name: "scroll_arm",
		tags: [],
		singletag: ["dressmaker", "elf", "witch", "apprentice", "mummy", "fungal"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.1,
		items: ["ScrollArms"],
	},
	"scroll_leg": {
		name: "scroll_arm",
		tags: [],
		singletag: ["dressmaker", "elf", "witch", "apprentice", "mummy", "fungal"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.1,
		items: ["ScrollLegs"],
	},
	"scroll_verbal": {
		name: "scroll_arm",
		tags: [],
		singletag: ["dressmaker", "elf", "witch", "apprentice", "mummy", "fungal"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.1,
		items: ["ScrollVerbal"],
	},
	"mage": {
		name: "mage",
		tags: [],
		singletag: ["witch", "apprentice", "fungal", "elf", "dressmaker"],
		forbidtags: [],
		chance: 1.5,
		items: ["PotionMana"],
	},
	"police": {
		name: "police",
		tags: ["police"],
		singletag: ["human", "bountyhunter"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.2,
		items: ["RedKey", "WristShackles", "BasicLeash"],
	},
	"ninja": {
		name: "ninja",
		tags: [],
		singletag: ["ninja", "maid", "bountyhunter"],
		forbidtags: [],
		chance: 0.7,
		items: ["SmokeBomb", "RopeSnakeArmsBoxtie", "DiscPick"],
	},
	"bandit_I": {
		name: "bandit_I",
		tags: [],
		singletag: ["bandit"],
		forbidtags: [],
		chance: 0.3,
		items: ["Bomb", "BasicLeash"],
	},
	"bandit_II": {
		name: "bandit_II",
		tags: [],
		singletag: ["bandit"],
		forbidtags: [],
		chance: 0.7,
		items: ["Bola", "BasicLeash"],
	},
	"bandit_III": {
		name: "bandit_III",
		tags: ["bandit"],
		singletag: ["miniboss", "boss", "elite"],
		forbidtags: [],
		chance: 0.5,
		items: ["PotionStamina", "Bola", "Knife", "DiscPick", "BasicLeash"],
	},
	"bandit_IV": {
		name: "bandit_IV",
		tags: ["bandit"],
		singletag: ["miniboss", "boss", "elite"],
		forbidtags: [],
		chance: 0.5,
		multiplier: 5,
		items: ["PotionWill", "Bomb", "Rope", "BasicLeash"],
	},
	"bandit_V": {
		name: "bandit_V",
		tags: ["bandit"],
		singletag: ["miniboss", "boss"],
		forbidtags: [],
		chance: 0.1,
		multiplier: 10,
		items: ["PotionStamina", "RedKey", "RedKey", "DiscPick", "BasicLeash"],
	},
	"miner": {
		name: "miner",
		tags: ["miner"],
		singletag: ["miner"],
		forbidtags: [],
		chance: 1.0,
		items: ["Bomb", "Bomb", "Bomb"],
	},
	"trainer": {
		name: "trainer",
		tags: ["trainer"],
		singletag: ["trainer"],
		forbidtags: [],
		chance: 0.4,
		items: ["AncientPowerSource", "RedKey", "BasicLeash"],
	},
	"nevermere": {
		name: "nevermere",
		tags: ["nevermere"],
		singletag: ["trainer", "wolfgirl"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.15,
		items: ["AncientPowerSource"],
	},
	"nevermere2": {
		name: "nevermere2",
		tags: ["nevermere"],
		singletag: ["trainer", "wolfgirl"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.15,
		items: ["FlashBomb"],
	},
	"nevermere3": {
		name: "nevermere3",
		tags: ["nevermere"],
		singletag: ["trainer", "wolfgirl"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.15,
		items: ["KeyCard"],
	},
	"cyborg": {
		name: "cyborg",
		tags: ["cyborg"],
		singletag: ["jailer"],
		forbidtags: [],
		chance: 0.30,
		items: ["KeyCard"],
	},
	"cyborg2": {
		name: "cyborg2",
		tags: ["cyborg"],
		singletag: ["jailer"],
		forbidtags: [],
		chance: 0.15,
		items: ["KeyCard", "AncientPowerSource"],
	},
	"nevermerespent": {
		name: "nevermerespent",
		tags: ["nevermere"],
		singletag: ["trainer", "wolfgirl"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.5,
		items: ["AncientPowerSourceSpent"],
	},
	"elemental_Fire": {
		name: "elemental_Fire",
		tags: ["jailer"],
		singletag: ["fire"],
		forbidtags: [],
		chance: 1.0,
		items: ["PotionMana"],
	},
	"elemental_Ice": {
		name: "elemental_Ice",
		tags: ["jailer"],
		singletag: ["ice"],
		forbidtags: [],
		chance: 1.0,
		items: ["PotionFrigid"],
	},
	"elemental_Ice2": {
		name: "elemental_Ice2",
		tags: ["jailer"],
		singletag: ["ice"],
		forbidtags: [],
		chance: 1.0,
		items: ["PotionFrigid", "IceRune"],
	},
	"elemental_Water": {
		name: "elemental_Water",
		tags: ["jailer"],
		singletag: ["water"],
		forbidtags: [],
		chance: 1.0,
		items: ["WaterRune"],
	},
	"elemental_Earth": {
		name: "elemental_Earth",
		tags: ["jailer"],
		singletag: ["earth"],
		forbidtags: [],
		chance: 1.0,
		items: ["EarthRune"],
	},
	"elemental_Rope": {
		name: "elemental_Rope",
		tags: ["jailer"],
		singletag: ["rope"],
		forbidtags: [],
		chance: 1.0,
		items: ["RopeRune"],
	},
	"elemental_Air": {
		name: "elemental_Air",
		tags: ["jailer"],
		singletag: ["air"],
		forbidtags: [],
		chance: 1.0,
		items: ["PotionStamina"],
	},
	"agent": {
		name: "agent",
		tags: [],
		singletag: ["ninja", "maid", "bountyhunter"],
		forbidtags: [],
		chance: 0.1,
		items: ["SmokeBomb", "PotionInvisibility", "DiscPick", "FlashBomb"],
	},
	"banditchief": {
		name: "banditchief",
		tags: ["bandit"],
		singletag: ["boss", "miniboss"],
		forbidtags: [],
		chance: 0.3,
		items: ["PotionStrength", "DiscPick", "PotionWill"],
	},
	"ninja_II": {
		name: "ninja_II",
		tags: [],
		singletag: ["ninja", "maid", "bountyhunter"],
		forbidtags: [],
		chance: 0.3,
		items: ["SmokeBomb", "FlashBomb", "DiscPick"],
	},
	"religious": {
		name: "religious",
		tags: ["religious"],
		singletag: ["mummy", "elf"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.01,
		items: ["ScrollPurity"],
	},
	"religiousElite": {
		name: "religiousElite",
		tags: ["religious", "elite"],
		singletag: ["mummy", "elf"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.2,
		multiplier: 4,
		items: ["ScrollPurity", "PotionMana", "BlueKey", "BasicLeash"],
	},
	"religiousMiniboss": {
		name: "religiousMiniboss",
		tags: ["religious", "miniboss"],
		singletag: ["mummy", "elf"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.5,
		multiplier: 10,
		items: ["ScrollPurity", "PotionMana", "BlueKey", "BasicLeash"],
	},
	"religiousBoss": {
		name: "religiousBoss",
		tags: ["religious", "boss"],
		singletag: ["mummy", "elf"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.8,
		multiplier: 10,
		items: ["ScrollPurity", "PotionMana", "BlueKey", "BasicLeash"],
	},
	"keyholder": {
		name: "keyholder",
		tags: ["miniboss"],
		singletag: ["human", "elf", "alchemist", "dragon", "witch", "apprentice", "mummy", "jailer"],
		forbidtags: ["submissive", "gagged"],
		chance: 0.22,
		multiplier: 2,
		items: ["Keyring", "BasicLeash"],
	},
	"potMana_minor": {
		name: "potMana_minor",
		tags: ["jailer"],
		singletag: [],
		forbidtags: [],
		chance: 0.05,
		items: ["PotionMana"],
	},
	"potStam_minor": {
		name: "potStam_minor",
		tags: ["jailer"],
		singletag: [],
		forbidtags: [],
		chance: 0.05,
		items: ["PotionStamina"],
	},
	"potWill_minor": {
		name: "potWill_minor",
		tags: ["jailer"],
		singletag: [],
		forbidtags: [],
		chance: 0.04,
		items: ["PotionWill"],
	},
	"potMana": {
		name: "potMana",
		tags: [],
		singletag: ["jailer"],
		forbidtags: ["minor"],
		chance: 0.1,
		items: ["PotionMana"],
	},
	"potStam": {
		name: "potStam",
		tags: ["jailer"],
		singletag: [],
		forbidtags: ["minor"],
		chance: 0.05,
		items: ["PotionStamina"],
	},
	"potWill": {
		name: "potWill",
		tags: ["jailer"],
		singletag: [],
		forbidtags: ["minor"],
		chance: 0.04,
		items: ["PotionWill"],
	},
	"potFrigid": {
		name: "potFrigid",
		tags: ["jailer"],
		singletag: [],
		forbidtags: ["minor"],
		chance: 0.08,
		items: ["PotionFrigid"],
	},
	"boss": {
		name: "boss",
		tags: ["boss"],
		singletag: ["human", "elf", "alchemist", "dragon", "witch", "apprentice", "mummy"],
		forbidtags: ["submissive", "gagged"],
		chance: 1.0,
		items: ["RedKey", "Keyring", "BasicLeash"],
	},
};
